import React, { Component } from 'react'
import { object, func } from 'prop-types'

class WorkflowStepUpload extends Component {
  constructor (props) {
    super(props)

    this.state = {
      submitting: false
    }
  }
  render () {
    const { completed, link, _id } = this.props.step
    if (completed) {
      return (
        <div className='pull-right'>
          <a href={link} className='btn btn-link' download>
            Download
          </a>
        </div>
      )
    } else {
      return (
        <div>
          <input
            className='form-control'
            type='file'
            ref={input => {
              this.filesInput = input
            }}
          />
          <div className='pull-right mt20'>
            <button
              className='btn btn-primary btn-sm'
              onClick={event => {
                this.setState({ submitting: true })
                this.props.submit(_id, 'upload', this.filesInput.files[0])
              }}
              disabled={this.state.submitting}
            >
              Enviar
            </button>
          </div>
        </div>
      )
    }
  }
}

WorkflowStepUpload.propTypes = {
  step: object,
  submit: func
}

export default WorkflowStepUpload



// WEBPACK FOOTER //
// ./src/components/WorkflowStepUpload.js